/*!
=========================================================
* Painel Toca da Onça — Regiões (onde estão as clientes)
=========================================================
* Dados reais do crm_carmen.json via stats.json.
*/
import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Badge } from "reactstrap";

const UF_NOME = {
  SP: "São Paulo", PE: "Pernambuco", MG: "Minas Gerais", RS: "Rio Grande do Sul",
  PR: "Paraná", SC: "Santa Catarina", RJ: "Rio de Janeiro", BA: "Bahia",
  CE: "Ceará", GO: "Goiás", PB: "Paraíba", ES: "Espírito Santo", PA: "Pará",
  DF: "Distrito Federal", MA: "Maranhão", RN: "Rio Grande do Norte", AL: "Alagoas",
};

const PADRAO = { regioes: [], revendedoras: 0, fornecedores: 0 };

function Regioes() {
  const [stats, setStats] = React.useState(PADRAO);
  React.useEffect(() => {
    fetch("/stats.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d) setStats({ ...PADRAO, ...d });
      })
      .catch(() => {});
  }, []);

  const regioes = stats.regioes || [];
  const maior = regioes.length ? regioes[0].total : 1;

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>
            Onde estão suas clientes
          </h3>
          <p className="text-muted">
            Distribuição real das revendedoras por estado. A Carmen usa isso pra oferecer o
            produto certo por região.
          </p>
        </Col>
      </Row>
      <Row>
        <Col lg="4" md="6">
          <Card className="card-stats">
            <CardBody>
              <p className="card-category text-muted">Revendedoras (clientes)</p>
              <CardTitle tag="h2" className="text-success">
                {stats.revendedoras.toLocaleString("pt-BR")}
              </CardTitle>
            </CardBody>
          </Card>
        </Col>
        <Col lg="4" md="6">
          <Card className="card-stats">
            <CardBody>
              <p className="card-category text-muted">Fornecedores / serviços</p>
              <CardTitle tag="h2" className="text-info">
                {stats.fornecedores.toLocaleString("pt-BR")}
              </CardTitle>
            </CardBody>
          </Card>
        </Col>
        <Col lg="4" md="6">
          <Card className="card-stats">
            <CardBody>
              <p className="card-category text-muted">Estados alcançados</p>
              <CardTitle tag="h2" className="text-warning">
                {regioes.length}
              </CardTitle>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Ranking por estado</CardTitle>
            </CardHeader>
            <CardBody>
              {regioes.map((r, i) => (
                <div key={i} style={{ marginBottom: 16 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                    <span className="text-white">
                      <Badge color="primary" pill style={{ marginRight: 8 }}>{r.uf}</Badge>
                      {UF_NOME[r.uf] || r.uf}
                    </span>
                    <span className="text-white" style={{ fontWeight: 600 }}>
                      {r.total.toLocaleString("pt-BR")}
                    </span>
                  </div>
                  <div style={{ background: "rgba(255,255,255,.08)", borderRadius: 6, height: 10 }}>
                    <div
                      style={{
                        width: Math.max(3, (r.total / maior) * 100) + "%",
                        height: "100%",
                        borderRadius: 6,
                        background: "linear-gradient(90deg,#e14eca,#ba54f5)",
                      }}
                    />
                  </div>
                </div>
              ))}
              {regioes.length === 0 && (
                <p className="text-muted">Sem dados ainda. Rode o coletor: node scripts/fetch-stats.js</p>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Regioes;
